import { clsx } from 'clsx';
import { ButtonHTMLAttributes, ReactNode } from 'react';

import cn from './styles.module.scss';

interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
    background?: 'primary' | 'secondary' | 'transparent';
}

export const Button = ({ children, background = 'primary', ...props }: IButton) => {
    return (
        <button
            {...props}
            className={clsx(
                cn.button,
                background === 'primary' && cn.buttonBgBrand4,
                background === 'secondary' && cn.buttonBgNeutral300,
                background === 'transparent' && cn.buttonBgTransparent,
                props.className
            )}
        >
            {children}
        </button>
    );
};
